import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import {
  TValidateDocumentRequest,
  TValidateDocumentResponse,
} from '~/store/remote-banking-contacts/types.ts';

export const validateDocumentRemoteBankingContacts = createAsyncThunk<
  TValidateDocumentResponse,
  TValidateDocumentRequest
>(
  'remoteBankingContacts/validateDocument',
  async ({ applicationId, documentId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const { data } = await api.post(
        `/remote-banking-contacts/applications/${applicationId}/documents/${documentId}/verify`,
        null,
        {
          headers,
        }
      );
      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
